const sendWorkWithUsApplication = async (formData) => {
  // =====================================================
  // CREAR FORM DATA
  // =====================================================

  const data = new FormData();

  data.append("name", formData.name);
  data.append("phone", formData.phone);
  data.append("email", formData.email);
  data.append("position", formData.position);
  data.append("message", formData.message);

  // =====================================================
  // ADJUNTAR ARCHIVO
  // =====================================================

  if (formData.file instanceof File) {
    data.append("file", formData.file);
  }

  // =====================================================
  // ENVIAR PETICIÓN AL BACKEND PHP
  // =====================================================

  let response;

  try {
    // Si es local
    //     const response = await fetch(
    //   "http://localhost/websitegsa/server/api/send-work-with-us.php",
    //   {
    //     method: "POST",
    //     body: data,
    //   }
    // );

    response = await fetch("/server/api/send-work-with-us.php", {
      method: "POST",
      body: data,
    });
  } catch (error) {
    console.error("Error de conexión con el servidor:", error);

    throw new Error(
      "No fue posible conectar con el servidor. Verifica que Apache esté ejecutándose en Laragon.",
    );
  }

  // =====================================================
  // LEER RESPUESTA DEL SERVIDOR
  // =====================================================

  let result;

  try {
    result = await response.json();
  } catch (error) {
    console.error(
      "Respuesta recibida del servidor:",
      await response.text().catch(() => ""),
    );

    throw new Error("El servidor devolvió una respuesta no válida.");
  }

  // =====================================================
  // VALIDAR RESPUESTA
  // =====================================================

  if (!response.ok) {
    throw new Error(
      result?.message ||
        `El servidor respondió con el código ${response.status}.`,
    );
  }

  if (!result || result.success !== true) {
    throw new Error(result?.message || "No fue posible enviar la postulación.");
  }

  // =====================================================
  // DEVOLVER RESPUESTA AL COMPONENTE
  // =====================================================

  return result;
};

// =====================================================
// EXPORTAR SERVICIO
// =====================================================

export { sendWorkWithUsApplication };
